import styled from 'styled-components';

export const Spacer = styled.div`
  flex: 1;
`;
